module.exports = {
      id: "icon-playstore-usage",
      viewBox: "0 0 190.654 62.305",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#icon-playstore",
      toString: function () {
        return this.url;
      }
    }